/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Doctor from './Doctor/index'
import Practice from './Practice/index'
import React from 'react'
import SendAction from './SendAction/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Empty"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 text="This patient isn't in Dental Monitoring yet."
/>
<div
  data-testid="Empty.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Doctor
  viewPath={`${viewPath}/Doctor`}
/>
<Practice
  viewPath={`${viewPath}/Practice`}
/>
<SendAction
  viewPath={`${viewPath}/SendAction`}
/>
</div>
{children}
</React.Fragment>)
}